import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12dbea5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pass_card_wrapper" }
const _hoisted_2 = { class: "pass_card_body" }
const _hoisted_3 = { class: "pass_card_title" }
const _hoisted_4 = { class: "pass_card" }
const _hoisted_5 = { class: "pass_card_text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "pass_card_img",
  src: "/assets/img/load-animation.svg"
}, null, -1))
const _hoisted_7 = { class: "pass_card_buttons_wrapper" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.title)), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('pass_card.pass_card_alert.attach_card')), 1),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "secondary_button",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('close')))
        }, _toDisplayString(_ctx.$t('pass_card.pass_card_alert.cancel')), 1)
      ])
    ])
  ]))
}